'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js'], function (Vue) {
	Vue.component('fill-blanks-game-completed', {
		props: ['initData'],
		computed: {

		},
		template:
		'<div class="text-center">' +
			'<h2>{{initData.translations.finished}}</h2>' +
		'</div>',
	});
});
